import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { StudyInfoClinicQuery, StudyInfoClinicQueryVariables } from '@/shared/api';
import STUDY_INFO_CLINIC_QUERY from '../queries/studyInfoClinic';

/**
 * Loads the clinic-facing information of a study. Runs STUDY_INFO_CLINIC_QUERY and throws the first GraphQL error message when the study field is nil.
 *
 * @param id - Identifier of the study to load.
 * @returns The clinic study information.
 */
const fetchStudyInfoClinic = async (id: any) => {
  const client = createClient();
  const studyInforesult = await client.query<StudyInfoClinicQuery, StudyInfoClinicQueryVariables>({
    query: STUDY_INFO_CLINIC_QUERY,
    variables: {
      id,
    },
  });
  const { data, errors } = studyInforesult;
  const { study: studyInfo } = data;
  if (_.isNil(studyInfo) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return studyInfo;
};

export default fetchStudyInfoClinic;
